import { render } from "./automaticRecycling.vue?vue&type=template&id=7b047274&scoped=true"
import script from "./automaticRecycling.vue?vue&type=script&lang=js"
export * from "./automaticRecycling.vue?vue&type=script&lang=js"

import "./automaticRecycling.vue?vue&type=style&index=0&id=7b047274&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b047274"

export default script